<div id="mixedWrapper">
    <svg id="mixed">
    </svg>
</div>
